export function isTestTeamName(name?: string | null) {
  if (!name) return false;
  const lowerName = name.toLowerCase();
  return (
    lowerName.startsWith('side -') ||
    lowerName.startsWith('side test') ||
    lowerName.startsWith('side demo')
  );
}
